export const SLIDE_DELAY = 6000;
